var _rect, _path, _g, _path2, _path3, _path4, _path5, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0D5FB6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1763_14731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2022 9.99946C17.8776 9.99946 17.5814 9.81992 17.4678 9.55062C17.0134 8.61701 16.2628 7.82345 15.3053 7.2597C14.713 6.90781 14.0557 6.65645 13.3619 6.51641C12.4612 6.34406 11.5281 6.34406 10.6274 6.51641C9.34122 6.77495 8.19303 7.41411 7.37347 8.32616C7.02049 8.6996 6.73649 9.11972 6.52551 9.56857C6.42408 9.7912 6.19688 9.95278 5.9291 9.99228C5.88447 9.99946 5.83984 10.0031 5.79116 10.0031C5.35298 10.0031 5 9.68706 5 9.30285C5 9.21667 5.01623 9.13409 5.05274 9.05509C6.62289 5.81621 10.7653 4.21114 14.5223 5.38173C15.8693 5.80544 17.054 6.5595 17.9425 7.55415C18.328 7.98863 18.6525 8.4662 18.9041 8.96891C18.9893 9.11613 19.0177 9.28131 18.9812 9.44289C18.9122 9.74093 18.6363 9.96714 18.2914 9.99946C18.263 9.99946 18.2306 10.0031 18.2022 10.0031M8.0064 6.84317C7.02861 7.47515 6.26179 8.32616 5.78304 9.31003L5.80739 9.29567C6.04676 8.78219 6.3754 8.30103 6.78112 7.87732C7.14627 7.49669 7.5601 7.14839 8.01045 6.84317M16.1208 6.92217C17.0296 7.54337 17.7478 8.36207 18.1981 9.29567V9.30285L18.2184 9.29208C18.2184 9.2849 18.2103 9.27413 18.1981 9.25617C17.7397 8.33693 17.0215 7.5326 16.1208 6.92217ZM12.0068 5.69054C11.9297 5.69054 11.8486 5.69054 11.7674 5.69413C11.4145 5.7049 11.0615 5.74081 10.7166 5.79826C11.309 5.7049 11.9135 5.67617 12.514 5.7049C12.3476 5.69413 12.1772 5.68694 12.0068 5.68694",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1763_14731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5723 1.82812H1.41797V13.1678H22.5723V1.82812Z",
    fill: "#F69F1A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1763_14731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 14,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7972 10.9531H5.24609V19H18.7972V10.9531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1763_14731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1763_14731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 15,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3685 10.7002H5.05469V19.5694H19.3685V10.7002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1763_14731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1763_14731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 14,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 11.1326C5.34241 11.0321 5.46413 10.971 5.59801 10.9638C6.00779 10.9638 6.42163 10.9531 6.83141 10.9674C7.03427 10.9854 7.19656 11.129 7.21684 11.3086C7.61851 12.7628 8.01611 14.2207 8.42184 15.6785C8.53949 16.1274 8.68555 16.5726 8.75858 17.0322C8.83973 17.4416 8.8519 17.8617 8.92899 18.2711C9.01825 17.6822 9.13996 17.0969 9.30631 16.5188C9.83375 14.7808 10.3612 13.0429 10.8846 11.305C10.9333 11.1075 11.1321 10.9674 11.3593 10.9674C11.8177 10.9567 12.2762 10.9674 12.7347 10.9674C12.9903 10.9495 13.2256 11.0895 13.3027 11.3086C13.6962 12.5761 14.0857 13.8436 14.4752 15.1112C14.7551 15.9227 14.9824 16.7486 15.1568 17.5816C15.1933 17.815 15.2298 18.0448 15.2866 18.2782C15.4854 16.9604 15.7695 15.657 16.1346 14.3715C16.3943 13.3409 16.6499 12.3068 16.9136 11.2762C16.9744 11.0787 17.1895 10.9495 17.4167 10.971C17.7859 10.971 18.1592 10.9602 18.5284 10.9746C18.7069 10.989 18.8367 11.129 18.8205 11.2834C18.8205 11.3121 18.8083 11.3409 18.7961 11.366C18.0537 13.7934 17.3112 16.2207 16.5687 18.6481C16.5281 18.8456 16.3415 18.9892 16.1143 18.9964C15.5422 19.0144 14.9661 19 14.39 19.0036C14.179 19.0287 13.9802 18.9102 13.9315 18.7271C13.4163 17.0574 12.9132 15.3877 12.406 13.718C12.2397 13.1327 12.1301 12.5366 12.0693 11.9369C12.0003 12.472 11.8989 13.007 11.769 13.5312C11.2497 15.2512 10.7263 16.9712 10.203 18.6912C10.1462 18.9713 9.78506 19.0251 9.51728 19.0072C8.98173 19 8.45024 19.0179 7.91874 19C7.73211 18.9964 7.57793 18.8743 7.54953 18.7091C6.79895 16.2925 6.05242 13.876 5.3059 11.4594C5.28561 11.3552 5.27749 11.2475 5.27749 11.1398",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1763_14731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1763_14731",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 15,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3959 10.707H5.08203V19.5762H19.3959V10.707Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1763_14731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4268 7.79688H1.71875V22.1779H22.4268V7.79688Z",
    fill: "white"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkday);
export default __webpack_public_path__ + "static/media/workday.f73ee9396dcebaa66be41477a60df613.svg";
export { ForwardRef as ReactComponent };